import { apiUrls } from 'consts'
import { useEffect } from 'react'
import getAll from 'utils/getAll'

interface useInitProps {
  setDataLoaded: Function
  setShowOverlay: Function
  setStates: Function
  setAllStates: Function
  setCountries: Function
  setCurrentCountry: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    getAll(apiUrls.states).then((data) => {
      props.setStates(data)
      props.setAllStates(data)
    })
    getAll(apiUrls.countries)
      .then((data) => props.setCountries(data))
      .then(() => {
        props.setDataLoaded(true)
        props.setShowOverlay(false)
      })
  }, [])
}

export default useInit
